import React from "react";
import { SubscriptionPlanCardContainer } from "./SubscriptionPlanCard.style";

import { useNavigate } from "react-router-dom";


import CustomButton from "Components/Commons/CustomButton/CustomButton";

const SubscriptionPlanCard = ({
    title,
    highlight,
    description,
    pricetext,
    price,
    bgColor,
    className = "",
    name
}) => {

    const navigate = useNavigate();

    const handleLearnMore = () => {
        navigate("/subscription", { state: { plan: name } });
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <SubscriptionPlanCardContainer className={`mygrid-col-lg-4 mygrid-col-md-12 subscription-card-col ${className}`}>

            <div
                className="subscription-card"
                style={{ backgroundColor: bgColor }}
            >
                <div className="subscription-card-inner">
                    <div className="subscription-card-top">
                        <h3>{title}</h3>
                        <p className="redfont sub_text-plan">{highlight}</p>
                        <p>{description}</p>
                    </div>
                    <div className="subscription-card-bottom">
                        <span className="price_plans">
                            {pricetext} <strong>{price}</strong>
                        </span>
                        <CustomButton
                            onClick={handleLearnMore}
                            text="Learn More"
                        />
                    </div>
                </div>
            </div>

        </SubscriptionPlanCardContainer>
    );
};


export default SubscriptionPlanCard;
